/* eslint-disable padding-line-between-statements */
import _ from 'lodash';

/**
 * US12684 - CE - Policy Summary
 */
const HIDE_COVERAGE_MAP_TWIA = [
    {coverageName: 'Structure', covTermNames: ['Valuation Method', 'Coinsurance']},
    {coverageName: 'Personal Property', covTermNames: ['Valuation Method']}
];

/**
 * US12684 - CE - Policy Summary
 * This function excludes the covTermNames, passed in the map.
 * @param [*] hideCoverageMap
 * @returns {function(...[*]=)}
 */

const excludeCoverageTermsTwia = hideCoverageMap => coverage => {
    const found = _.find(hideCoverageMap, {coverageName: coverage.name});
    if (found) {
        coverage.terms = _.filter(coverage.terms, t => !_.includes(found.covTermNames, t.name));
    }
};
const hoExcludeCoverageTermsTwia = excludeCoverageTermsTwia(HIDE_COVERAGE_MAP_TWIA);

/**
 * US12684 - CE - Policy Summary
 * The function transforms the coverages, so the model can be passed to <gw-pc-ho-view-coverages> directive.
 *  - Creates reference objects to baseCoverages and additionalCoverages
 *  - Strips the coverageTerms that are to be hidden from CE, based on the map.
 *      The coverageTerm stripping happens in the UI, as the back-end already handles the hide attributes for PE,
 *      and introducing another attribute for CE, will increase the complexity of back-end APIs.
 * @param {*} lobData
 */
const transformCoveragesTwia = lobData => {
    Object.assign(
        lobData,
        {baseCoverages: lobData.baseCoverages_TWIA},
        {additionalCoverages: lobData.additionalCoverages_TWIA},
        {indirectLossCoverages_TWIA: lobData.indirectLossCoverages_TWIA}, // 2021-11-02 - Debra Frum - US17826 - Residential Rating/Premiums
        {exclusionsArray_TWIA: lobData.exclusions_TWIA} // DE12259 - Exclusions and Conditions are not displayed
    );
    _.forEach(lobData.baseCoverages, hoExcludeCoverageTermsTwia);
};

class TWIAHoCoverageTermHelper {
    static transformAndHideNonVisibleCoverageTerms(lobData) {
        transformCoveragesTwia(lobData);
    }
}

export default TWIAHoCoverageTermHelper;